"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var room_error_code_1 = require("../../../websocket-channel/room-error-code");
var login_interface_1 = require("./login.interface");
/**
 * 页面关闭时检查器
 * 1. 断开 bind 连接
 */
var PageUnloadChecker = /** @class */ (function () {
    function PageUnloadChecker(dependency) {
        var _this = this;
        this.dependency = dependency;
        this.disconnect = function () {
            _this.dependency.disconnect({
                reason: 'close by client, beforeunload',
                // 不需要 shutDown。如果 beforeunload 后，用户选择不关页面，那么就会自动重连
                shutDown: false,
                errCode: room_error_code_1.RoomErrorCode.ROOM_CLOSE,
                reconnectTime: login_interface_1.PAGE_UNLOAD_TIME,
            });
        };
        // 为什么不用 unload 事件断开连接？因为 chrome 刷新页面不会触发 unload 事件
        this.addBeforeunloadListener(this.disconnect);
    }
    PageUnloadChecker.prototype.addBeforeunloadListener = function (handler) {
        window.addEventListener('beforeunload', handler);
    };
    return PageUnloadChecker;
}());
exports.default = PageUnloadChecker;
